import { useRaffleMutations } from '@/app/hooks/useRaffleMutations'
import { Button } from '@/view/components/ui/button'
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from '@/view/components/ui/dialog'
import {
  InputOTP,
  InputOTPGroup,
  InputOTPSlot,
} from '@/view/components/ui/input-otp'
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@/view/components/ui/tooltip'
import { REGEXP_ONLY_DIGITS } from 'input-otp'
import { Ticket } from 'lucide-react'
import { Fragment, useState } from 'react'

interface DrawRaffleProps {
  raffleId: string
  hasCoupons: boolean
}

export function DrawRaffle({ raffleId, hasCoupons }: DrawRaffleProps) {
  const [open, setOpen] = useState(false)
  const { drawRaffle } = useRaffleMutations()
  const [code, setCode] = useState('')

  const hasCode = code.length > 0
  const isCodeInvalid = hasCode && code?.length !== 6
  const isPending = drawRaffle.isPending

  const handleDrawRaffle = async () => {
    if (isCodeInvalid) return
    try {
      await drawRaffle.mutateAsync({ raffleId, code })
      setCode('')
      setOpen(false)
    } catch (error) {
      console.error(error)
    }
  }

  return (
    <Fragment>
      <TooltipProvider>
        <Tooltip>
          <TooltipTrigger asChild>
            <span>
              <Dialog open={open} onOpenChange={setOpen}>
                <DialogTrigger asChild>
                  <Button
                    variant="default"
                    size="lg"
                    className="rounded-full text-white"
                    disabled={isPending || !hasCoupons}
                    onClick={() => setOpen(true)}
                  >
                    <Ticket size={20} className="mr-2" />
                    Sortear
                  </Button>
                </DialogTrigger>
                <DialogContent className="max-w-sm">
                  <DialogHeader>
                    <DialogTitle>Sortear</DialogTitle>
                  </DialogHeader>

                  <div className="flex flex-col gap-4">
                    <p className="text-sm text-muted-foreground">
                      Para sortear um cupom específico, digite o código no campo
                      abaixo. Caso contrário, todos os cupons do sorteio serão
                      sorteados <strong>aleatoriamente</strong>.
                    </p>
                    <InputOTP
                      maxLength={6}
                      value={code}
                      onChange={(value) => setCode(value)}
                      pattern={REGEXP_ONLY_DIGITS}
                      className="w-full"
                    >
                      <InputOTPGroup className="w-full">
                        <InputOTPSlot index={0} className="w-full text-lg" />
                        <InputOTPSlot index={1} className="w-full text-lg" />
                        <InputOTPSlot index={2} className="w-full text-lg" />
                        <InputOTPSlot index={3} className="w-full text-lg" />
                        <InputOTPSlot index={4} className="w-full text-lg" />
                        <InputOTPSlot index={5} className="w-full text-lg" />
                      </InputOTPGroup>
                    </InputOTP>
                    <Button
                      variant="default"
                      size="lg"
                      className="rounded-full text-white"
                      disabled={isPending || !hasCoupons || isCodeInvalid}
                      onClick={handleDrawRaffle}
                    >
                      <Ticket size={20} className="mr-2" />
                      Sortear
                    </Button>
                  </div>
                </DialogContent>
              </Dialog>
            </span>
          </TooltipTrigger>
          {!hasCoupons && (
            <TooltipContent>
              Esse sorteio não possui cupons válidos para sorteio
            </TooltipContent>
          )}
        </Tooltip>
      </TooltipProvider>
    </Fragment>
  )
}
